
import WorkCycleEvaluationTableContainer from './WorkCycleEvaluationTableContainer';

export default WorkCycleEvaluationTableContainer;